// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardSkeleton-moduleskeletonBar__myyC2 Skeleton-moduleSkeleton__Mlrfv";
var _2 = "BirdviewCardSkeleton-moduleskeletonRow__WZLdZ";
export { _1 as "skeletonBar", _2 as "skeletonRow" }
